import { render, staticRenderFns } from "./DownloadVideo.vue?vue&type=template&id=59d8267f&lang=pug&"
import script from "./DownloadVideo.vue?vue&type=script&lang=js&"
export * from "./DownloadVideo.vue?vue&type=script&lang=js&"
import style0 from "./DownloadVideo.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports